const copy = {
  heading: "No saved prompts yet",
  text: {
    getStarted: "To get started",
    link: "create a saved prompt.",
  },
};

export default copy;
